import { render, staticRenderFns } from "./ElectronicSign.vue?vue&type=template&id=2fcedd59&scoped=true&"
import script from "./ElectronicSign.vue?vue&type=script&lang=ts&"
export * from "./ElectronicSign.vue?vue&type=script&lang=ts&"
import style0 from "./ElectronicSign.vue?vue&type=style&index=0&id=2fcedd59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcedd59",
  null
  
)

export default component.exports